module.exports = __webpack_public_path__ + "static/media/ImgENG2.b23d5055.svg";